import { usePushHistory } from "../components/NavLink";
import { getApiBaseUrl } from "../config";
import { getParentUrl } from "../utils/helpers";
import { useEnv } from "./env";

export function useFetchContext() {
  const { stack } = useEnv();
  return {
    stack,
    ready: true,
  };
}
export function fetchWithContext(
  path,
  context,
  fetchParams,
  isJsonResponse = true
) {
  const domain = getParentUrl() || "";
  const newParams = {
    ...fetchParams,
    credentials: "include",
    headers: {
      ...fetchParams?.headers,
      // domain: "wolken-itsm-demo.wolkenservicedesk.com",
      domain,
    },
  };

  let apiDomain = getApiBaseUrl();

  const basename =
    // getBasename() ||
    `${apiDomain}/conductor-api/`;

  const newPath = basename + `api/${path}`;
  const cleanPath = cleanDuplicateSlash(newPath); // Cleanup duplicated slashes

  return fetch(cleanPath, newParams)
    .then((res) => Promise.all([res, res.text()]))
    .then(([res, text]) => {
      if(cleanPath.includes('/metadata/workflow/') && res.status===404){
        window.location.href = '/workflowDefs?error=true';
        const navigate = usePushHistory();
        navigate('/workflowDefs?error=true')
      }
      if (!res.ok) {
        // get error message from body or default to response status
        const error = text || res.status;
        return Promise.reject(error);
      } else if (!text || text.length === 0) {
        return null;
      } else if (!isJsonResponse) {
        return text;
      } else {
        try {
          return JSON.parse(text);
        } catch (e) {
          return text;
        }
      }
    });
}

export function cleanDuplicateSlash(path) {
  return path.replace(/([^:]\/)\/+/g, "$1");
}
